var antPrefixCls = '.ant-pagination';
var genPaginationStyle = function genPaginationStyle(token) {
  var _ref, _antPrefixCls, _ref2;
  return _ref2 = {}, _ref2[antPrefixCls] = (_antPrefixCls = {}, _antPrefixCls[".ant-pagination-jump-next,.ant-pagination-jump-prev"] = {
    '.ant-pagination-item-container': {
      '.ant-pagination-item-ellipsis': {
        color: token.colorTextSecondary,
        letterSpacing: '0'
      }
    }
  }, _antPrefixCls[antPrefixCls + "-item-active"] = {
    borderColor: 'transparent',
    a: {
      borderRadius: '4px'
    },
    '&:hover': {
      borderColor: 'transparent'
    }
  }, _antPrefixCls["&" + antPrefixCls + "-disabled"] = (_ref = {}, _ref[antPrefixCls + "-item-active"] = {
    borderColor: 'transparent',
    backgroundColor: token.colorFillSecondary
  }, _ref), _antPrefixCls['.ant-pagination-options-quick-jumper'] = {
    marginInlineStart: '20px'
  }, _antPrefixCls['.ant-pagination-options-quick-jumper input'] = {
    boxShadow: 'none!important',
    '&[disabled]': {
      borderColor: '#CACACC'
    }
  }, _antPrefixCls['&.ant-pagination-mini .ant-pagination-options-quick-jumper input'] = {
    fontSize: 12,
    height: 28
  }, _antPrefixCls), _ref2;
};
var paginationStyleFn = function paginationStyleFn(token) {
  return genPaginationStyle(token);
};

export { paginationStyleFn };
